export const PATH_TO_WASM = 'https://websdk1.blob.core.windows.net/sdk-1-2-3/'
export const SOCKET_URL = 'wss://rppg-dev2.xyz/vp/bgr_signal_socket'